import clsx from "clsx";
import * as React from "react";
import { MarginProps } from "@radix-ui/themes/props";
import { Spinner, Text } from "@radix-ui/themes";

export const getStatusColor = (
  state: "success" | "waiting" | "error",
): "green" | "gray" | "red" => {
  switch (state) {
    case "success":
      return "green";
    case "waiting":
      return "gray";
    case "error":
      return "red";
  }
};

export interface StatusProps
  extends Omit<React.ComponentPropsWithoutRef<"span">, "color">, MarginProps {
  children?: React.ReactNode;
  state: "success" | "waiting" | "error";
}

const Status = React.forwardRef<HTMLSpanElement, StatusProps>(
  ({ className, ...props }, forwardedRef) => (
    <Text
      ref={forwardedRef}
      className={clsx(className, "woswidgets-status")}
      data-state={props.state}
      {...props}
      size="2"
      color={getStatusColor(props.state)}
    >
      {props.state === "waiting" && <Spinner />}
      {props.children}
    </Text>
  ),
);

Status.displayName = "Status";

export { Status };
